import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { EXPORT_TEMPLATES_CRUD_ACTION_CREATORS } from '../actions/export_templates_actions';

export const exportTemplatesRestCrudThunksForBuyer = new RestCrudThunks(
	'export_templates',
	'export_template',
	'exportTemplate',
	'exportTemplates',
	EXPORT_TEMPLATES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'export/'
);

export const exportTemplatesRestCrudThunksForSupplier = new RestCrudThunks(
	'export_templates',
	'export_template',
	'exportTemplate',
	'exportTemplates',
	EXPORT_TEMPLATES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'export/'
);

export const exportTemplatesRestCrudThunks = (roleType) =>
	roleType === ROLE_TYPES.SUPPLIER
		? exportTemplatesRestCrudThunksForSupplier
		: exportTemplatesRestCrudThunksForBuyer;
